import React, { useState, useEffect } from "react";
import styled from "styled-components";
import useRouting from "../hooks/useRouting.js";
import { useParams } from "react-router";
import louise_logo from "../assets/images/louise_logo.svg";
import {
  retrieveStorageById /*, patchStorage */,
} from "../helpers/storeService.js";
import FlowManualBikeForm from "../components/FlowManualBikeForm.jsx";
import i18n from "../i18n";

const FlowBikeInformation = () => {
  const defaultImg = louise_logo;
  const [carBrandImage, setCarBrandImage] = useState(defaultImg);
  const { renderNextRoute } = useRouting();
  const { id, affinity, insuranceType } = useParams();
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    loadDefaultValues();
  }, []);

  const loadDefaultValues = async () => {
    const { data } = retrieveStorageById(id, affinity, insuranceType);
    setDefaultValues(data?.twoWheeler?.details || {});
    setCarBrandImage(data?.twoWheeler?.details?.brandImg || defaultImg);
  };

  return (
    <SplitContainer>
      <LeftSplit>
        <RoundImageContainer>
          <RoundImage img={carBrandImage} alt="car brand logo" />
        </RoundImageContainer>
        <TextBalloon>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.t(
                "Next I need some information about your motorcycle You can fill it out here on the right"
              ),
            }}
          ></p>
        </TextBalloon>
      </LeftSplit>
      <RightSplit>
        <FlowManualBikeForm
          resetImage={(img) => setCarBrandImage(img)}
          renderNextRoute={renderNextRoute}
          defaultValues={defaultValues}
        />
      </RightSplit>
    </SplitContainer>
  );
};

const TextBalloon = styled.div`
  display: flex;
  font-size: 1.6rem;
  line-height: 1.5;
  width: 100%;
  border-radius: 0.5rem;
  color: #393939;
  background: #f3f3f3;
  padding: 3rem;
  margin-top: auto;
  > span {
    font-weight: 700;
  }
  .text {
    width: 90%;
  }
`;

const RightSplit = styled.div`
  width: 50%;
  padding: 5rem 4rem;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media screen and (max-width: 425px) {
    padding: 4rem 2.5rem;
  }
`;

const SplitContainer = styled.div`
  display: flex;
  height: 100%;
`;

const LeftSplit = styled.div`
  width: 50%;
  padding: 5rem 4rem;
  display: grid;
  grid-template-rows: 75% auto;
  grid-gap: 15px 0;
  justify-items: center;

  :after {
    content: "";
    width: 1px;
    height: 70%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 50%;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const RoundImage = styled.div`
  background-image: url(${(props) => props.img});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 100%;
`;

const RoundImageContainer = styled.div`
  max-width: 35rem;
  width: 100%;
  margin-top: auto;
`;

export default FlowBikeInformation;
